import {
  InspectorControls,
  MediaUpload,
  useBlockProps,
  useInnerBlocksProps,
} from '@wordpress/block-editor';
import apiFetch from '@wordpress/api-fetch';
import { useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { Button, Notice, PanelBody } from '@wordpress/components';
import classNames from 'classnames';

import { getStylesObjectsFromTailwindClasses } from '@components/DesignPanel/Helpers';
import { getNewDesignClasses } from '@components/DesignPanel/Helpers';
import { createBlock } from '@wordpress/blocks';

const { dispatch } = wp.data;

function addBiteAndFlexClassesToTemplate(template) {
  return template.map((element) => {
    const [type, attributes] = element;
    const content = attributes.content || '';
    const classString = attributes.class || '';
    const { biteStyle, flexStyle } =
      getStylesObjectsFromTailwindClasses(classString);

    return [
      type,
      {
        ...(content && { content }),
        biteClass: getNewDesignClasses(biteStyle),
        biteStyle,
        flexClass: getNewDesignClasses(flexStyle),
        flexStyle,
      },
    ];
  });
}

export default function Edit({ attributes, setAttributes, clientId }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const blockProps = useBlockProps();
  const { children, ...innerBlocksProps } = useInnerBlocksProps({
    className: classNames(
      'b_ai-generated',
      attributes.biteClass,
      attributes.flexClass
    ),
  });

  const onImageSelect = (image) => {
    setAttributes({ ...attributes, imageUrl: image.url });
    setLoading(true);
    setError(null);
    // Trigger OpenAI API call with the image
    apiFetch({
      path: `${blockbite.api}/block-helpers/generate_styles`,
      method: 'POST',
      data: { imageUrl: image.url },
    })
      .then((response) => {
        let allStyles = null;

        try {
          allStyles = JSON.parse(response.data);
        } catch (e) {
          setError('Invalid response from AI');
          return;
        }

        if (!allStyles) {
          setError('No AI styles found');
          return;
        }

        if (allStyles.parentClass) {
          const { biteStyle, flexStyle } = getStylesObjectsFromTailwindClasses(
            allStyles.parentClass
          );

          setAttributes({
            ...attributes,
            biteClass: getNewDesignClasses(biteStyle),
            biteStyle,
            flexClass: getNewDesignClasses(flexStyle),
            flexStyle,
          });
        }

        if (allStyles.template && allStyles.template.length) {
          const newTemplate = addBiteAndFlexClassesToTemplate(
            allStyles.template
          );

          newTemplate.forEach((element) => {
            const newBlock = createBlock(element[0], element[1]);
            dispatch('core/block-editor').insertBlocks(newBlock, 0, clientId);
          });
        }
      })
      .catch((error) => {
        setError(error?.message || 'An error occurred');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div {...blockProps}>
      <InspectorControls>
        <PanelBody title="Upload Image">
          <MediaUpload
            onSelect={onImageSelect}
            allowedTypes={['image']}
            render={({ open }) => (
              <Button onClick={open}>
                {!attributes.imageUrl ? 'Upload Image' : 'Change Image'}
              </Button>
            )}
          />
          {error && (
            <Notice status="error" className="mt-4">
              <p>{error}</p>
            </Notice>
          )}
        </PanelBody>
      </InspectorControls>
      {loading ? (
        <p>Loading AI Styles...</p>
      ) : (
        <div {...innerBlocksProps}>{children}</div>
      )}
    </div>
  );
}
